import {
	AfterViewInit,
	Component,
	ElementRef,
	Input, NgModule,
	ViewEncapsulation
} from '@angular/core';
import {NUMBER_OF_LINES} from 'shared/magic';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {Store} from '@ngrx/store';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {withLatestFrom} from 'rxjs/operators';
import * as fromJournal from '../../../../journal/src/_selectors/journal.selectors';
import {CommonModule} from '@angular/common';
import {TranslocoModule} from '@ngneat/transloco';

@UntilDestroy()
@Component({
	selector: 'shared-ellipsis',
	template: `
		<div class="content-container" [class.no-ellipsis]="expand">
			<article class="wrapper" [innerHTML]="sanitizedContent"></article>
		</div>
		<button class="toggle-content-btn btn shadow-none"
				*ngIf="showBtn"
				(click)="toggleContent($event)">
			<span class="lines-wrapper">
				<span class="info-wrapper"
					  *transloco="let t; read: 'textWithEllipsis'">
					{{ !expand ? (t('showMore') | lowercase) : (t('showLess') | lowercase)}}</span>
			</span>
		</button>
	`,
	styleUrls: ['./ellipsis.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class EllipsisComponent implements AfterViewInit {
	@Input() set content(c: string) {
		const cleaned = c.replace(/<br\s*\/?>/gi, '').replace(/&nbsp;/gi, '').trim();
		this.sanitizedContent = cleaned
			? this.sanitizer.bypassSecurityTrustHtml(cleaned)
			: null;
	}

	lines = NUMBER_OF_LINES;
	sanitizedContent: SafeHtml;
	showBtn: boolean;
	expand = false;

	constructor(
		private el: ElementRef,
		private sanitizer: DomSanitizer,
		private store: Store
	) { }

	ngAfterViewInit() {
		this.store.select(fromJournal.selectFoldContentLinesNumber).pipe(
			untilDestroyed(this),
			withLatestFrom(this.store.select(fromJournal.selectUnfoldContent))
		).subscribe(([linesNumber, unfold]) => {
			if (unfold) {
				this.lines = null;
				this.showBtn = false;
				this.expand = true;
				return;
			}
			this.lines = linesNumber as number || NUMBER_OF_LINES;
			this.calculateContentHeight();
		});
	}

	toggleContent(event: Event) {
		event.stopPropagation();
		this.expand = !this.expand;
	}

	calculateContentHeight() {
		const host = this.el.nativeElement;
		const contentContainer = host.children[0];
		const wrapper = host.querySelector('article.wrapper');
		const lineHeightProp = window.getComputedStyle(contentContainer).lineHeight;
		const lineHeight = Number(lineHeightProp?.substr(0, lineHeightProp.length - 2));

		const fullElHeight = wrapper.getBoundingClientRect().height;
		contentContainer.style.webkitLineClamp = this.lines;
		contentContainer.style.minHeight = `${this.lines * Number(lineHeight)}px`;
		const lineClampElHeight = contentContainer.getBoundingClientRect().height;

		setTimeout(() => {
			this.showBtn = fullElHeight > lineClampElHeight;
		});
	}
}

@NgModule({
	declarations: [EllipsisComponent],
	imports: [
		CommonModule,
		TranslocoModule
	],
	exports: [EllipsisComponent]
})
export class EllipsisModule {}
